import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { AuthGuardService } from './services/auth-guard.service';
import { authTokenGuard } from './guards/auth-token.guard';
import { requiredPrivilegeGuard } from './guards/required-privilege.guard';
import { otpRequestGuard } from './guards/otp-request.guard';
import { otpValidGuard } from './guards/otp-valid.guard';
import { CustomerVerificationComponent } from './components/customer-verification/customer-verification.component';
//import { DisbursementProfileComponent } from './components/disbursement-profile/disbursement-profile.component';
import { DisbursementOccurrencesComponent } from './components/disbursement-occurrences/disbursement-occurrences.component';
import { FundingAccountsComponent } from './components/funding-accounts/funding-accounts.component';
import { FundingAccountCardComponent } from './components/funding-account-card/funding-account-card.component';
import { FundingAccountAchComponent } from './components/funding-account-ach/funding-account-ach.component';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';

const routes: Routes = [
  //{ path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: ''       , component: CustomerVerificationComponent },
  { path: 'cv-comp', component: CustomerVerificationComponent },
  { 
    path: 'ov-comp', component: OtpVerificationComponent, 
    // canActivate: [authTokenGuard]
    canActivate: [authTokenGuard, otpRequestGuard, requiredPrivilegeGuard],
    data: { privileges: ['PRIV_MFA']}
  },
  { 
    path: 'dsb-card', 
    component: FundingAccountCardComponent, 
    canActivate: [authTokenGuard, otpValidGuard, requiredPrivilegeGuard],
    data: { privileges: ['PRIV_WD_FUNDING_ACCOUNTS_MODIFY']}
  },
  { 
    path: 'dsb-ach', 
    component: FundingAccountAchComponent, 
    canActivate: [authTokenGuard, otpValidGuard, requiredPrivilegeGuard],
    data: { privileges: ['PRIV_WD_FUNDING_ACCOUNTS_MODIFY']}
  },
  {
    path: 'dsb-funding-accounts',
    component: FundingAccountsComponent,  
    canActivate: [authTokenGuard, otpValidGuard, requiredPrivilegeGuard],
    data: { privileges: ['PRIV_WD_FUNDING_ACCOUNTS_VIEW','PRIV_WD_FUNDING_ACCOUNTS_MODIFY','PRIV_WD_DSB_SESSION_MODIFY']}
  },
  {
    path: 'dsb-ocr',
    component: DisbursementOccurrencesComponent,
    canActivate: [authTokenGuard, otpValidGuard, requiredPrivilegeGuard],
    data: { privileges: ['PRIV_WD_DSB_OCCURRENCES_VIEW','PRIV_WD_PAYMENTS_MODIFY']}
  }
];

@NgModule({
  // imports: [RouterModule.forRoot(routes, {useHash: true})],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

